import { apiClient } from '@/lib/api/client';

export const ratesApi = {
  getRates: () => apiClient.GET('/rates'),
};
